import React from 'react';

/** A legislative body as GET /api/admin/legislature/* serves it. */
export interface LegislativeBody {
  id: string;
  key: string;
  name: string;
  level: string;
  state_code: string | null;
  cycle_years: number;
  cycle_start_rule: string;
  has_sessions: boolean;
  numbered: boolean;
}

export interface CycleSession {
  session_key: string;
  label: string;
  short_label: string;
  type: 'regular' | 'special';
  convene_date: string | null;
  adjourn_date: string | null;
}

/** A cycle row (dates are 'YYYY-MM-DD'). */
export interface LegislativeCycleRow {
  id: string;
  body_id: string;
  number: number | null;
  label: string;
  start_date: string;
  end_date: string;
  dates_confirmed: boolean;
  notes: string | null;
  is_current: boolean;
  is_incoming: boolean;
  milestone_count: number;
  sessions: CycleSession[];
}

const chip = 'ml-2 inline-block whitespace-nowrap rounded px-1.5 py-0.5 text-[11px] font-medium';

/**
 * Current / Incoming / Expected dates — the Sessions tab's chip style. Incoming is
 * the outlined form of Current: the same meaning (the live cycle), one step ahead.
 */
export const CycleChips: React.FC<{ cycle: Pick<LegislativeCycleRow, 'is_current' | 'is_incoming' | 'dates_confirmed'> }> = ({ cycle }) => (
  <>
    {cycle.is_current && (
      <span className={`${chip} bg-primary-100 text-primary-700 dark:bg-primary-900 dark:text-primary-200`}>Current</span>
    )}
    {cycle.is_incoming && (
      <span className={`${chip} border border-primary-300 text-primary-700 dark:border-primary-700 dark:text-primary-200`}>Incoming</span>
    )}
    {!cycle.dates_confirmed && (
      <span
        className={`${chip} bg-warning-100 text-warning-700 dark:bg-warning-900 dark:text-warning-200`}
        title="Computed from the constitutional rule — confirm once the convene date is known"
      >
        Expected dates
      </span>
    )}
  </>
);
